/* Auditoria (Painel Administrativo) — quem fez o quê no painel.
 *
 * Ligada ao real `/api/audit` (escopado no backend aos tenants de quem
 * pergunta). Só leitura. Nebula. */

import React from 'react';

import { api } from '../api/cliente';
import { useRecurso } from '../estado/recurso';
import { relativo } from './formato';
import { Aviso, Cabecalho, Nota, Secao } from './ui';

const ACOES_ROTULO = {
  login: 'Entrou no painel',
  logout: 'Saiu do painel',
  criar_assistente: 'Cadastrou empresa',
  criar_empresa: 'Cadastrou empresa + acesso',
  reprocessar_run: 'Reprocessou uma resposta',
  assumir_atendimento: 'Assumiu uma conversa',
  responder: 'Respondeu numa conversa',
};

const th = {
  position: 'sticky', top: 0, textAlign: 'left', padding: '12px 20px',
  background: 'var(--surface-card)', font: 'var(--type-label)', fontWeight: 'var(--fw-semibold)',
  color: 'var(--text-muted)', letterSpacing: 'var(--ls-wide)', borderBottom: '1px solid var(--border-subtle)', whiteSpace: 'nowrap',
};
const td = { padding: '12px 20px', color: 'var(--text-secondary)', borderBottom: '1px solid var(--border-subtle)' };

export default function Auditoria() {
  const recurso = useRecurso((sinal) => api.auditoria(200, sinal), []);
  const itens = recurso.dados?.itens || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflow: 'hidden' }}>
      <Cabecalho titulo="Auditoria" descricao="O registro de quem fez o quê no painel — ações com autor, alvo e horário." />
      <div style={{ flex: 1, minHeight: 0, overflow: 'auto', padding: '0 24px 8px' }}>
        <Secao titulo={recurso.carregando ? 'Carregando…' : `${itens.length} ${itens.length === 1 ? 'registro' : 'registros'}`}>
          {recurso.erro ? (
            <Aviso titulo="A auditoria não carregou" texto={recurso.erro.mensagem} acao={recurso.erro.temporario ? 'Tentar de novo' : null} aoAcao={recurso.recarregar} />
          ) : !recurso.carregando && itens.length === 0 ? (
            <Aviso titulo="Nada registrado ainda" texto="As ações no painel aparecem aqui." />
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', font: 'var(--type-body)', fontSize: 'var(--fs-body-sm)' }}>
              <thead>
                <tr><th style={th}>Quem</th><th style={th}>Ação</th><th style={th}>Alvo</th><th style={{ ...th, textAlign: 'right' }}>Quando</th></tr>
              </thead>
              <tbody>
                {itens.map((a) => (
                  <tr key={a.id}>
                    <td style={{ ...td, color: 'var(--text-primary)' }}>{a.quem || '—'}</td>
                    <td style={td}>{ACOES_ROTULO[a.acao] || a.acao}</td>
                    <td style={{ ...td, fontFamily: 'var(--font-mono)', fontSize: 'var(--fs-label)' }}>{a.alvo || '—'}</td>
                    <td className="nb-tab" style={{ ...td, textAlign: 'right', color: 'var(--text-muted)' }}>{relativo(a.em)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Secao>
        <Nota>Fonte: /api/audit, restrito no backend aos tenants que você enxerga.</Nota>
      </div>
    </div>
  );
}
